// extracted by mini-css-extract-plugin
export default {"root":"QRCode_root__-AjvE","qrCodeWrapper":"QRCode_qrCodeWrapper__wEU5O","button":"QRCode_button__Tb9CT"};